/* eslint-disable no-unused-vars */
import { EHttpMethods } from "../../../../enums";
import {
  GET_BALANCE,
  AUTH_BASE_URL,
  PAYMENT_BASE_URL,
  PAYMENT_BASE_URL_V2,
  GET_TRANSACTION,
  GET_BANKS_INFO,
} from "../../../constants";
import { getToken } from "../../../context/authContext";
import { ApiServiceManager, fetchRequest } from "../../apiServiceManager";
import { IApiResponse } from "../../models";
import { CHECKOUT_PATH } from "./constants";

import {
  IBankResponse,
  ICashoutRequest,
  ICashoutResponse,
  ICheckoutRequest,
  ICheckoutResponse,
  IOrganizationBankInfoResponse,
  IPaymentLinkCashoutRequest,
} from "./models";

const defaultProvide = async () => await getToken();

export const getCheckoutId = (
  data: ICheckoutRequest
): Promise<IApiResponse> => {
  const url = `${PAYMENT_BASE_URL}${CHECKOUT_PATH}`;
  const descriptor = new ApiServiceManager(
    url,
    EHttpMethods.POST,
    defaultProvide
  );
  return fetchRequest(descriptor, data);
};

export const checkPaymentStatus = (id: string): Promise<ICheckoutResponse> => {
  const url = `${PAYMENT_BASE_URL}${id}/status`;
  const descriptor = new ApiServiceManager(
    url,
    EHttpMethods.GET,
    defaultProvide
  );
  return fetchRequest(descriptor);
};

export const getBankTransferDetails = (id: string): Promise<any> => {
  const url = `${PAYMENT_BASE_URL_V2}referenceTransactionId/${id}/bank-transfer-info`;
  const descriptor = new ApiServiceManager(
    url,
    EHttpMethods.GET,
    defaultProvide
  );
  return fetchRequest(descriptor);
};

export const makeCashOutPayment = (
  body: ICashoutRequest
): Promise<ICashoutResponse> => {
  const url = `${PAYMENT_BASE_URL_V2}cashout?referenceTransactionId=${body.referenceTransactionId}&amount=${body.amount}`;
  const descriptor = new ApiServiceManager(
    url,
    EHttpMethods.POST,
    defaultProvide
  );
  return fetchRequest(descriptor, body);
};

export const makeManualCashOutPayment = (
  body: ICashoutRequest
): Promise<ICashoutResponse> => {
  const url = `${PAYMENT_BASE_URL_V2}manual-cashout`;
  const descriptor = new ApiServiceManager(
    url,
    EHttpMethods.POST,
    defaultProvide
  );
  return fetchRequest(descriptor, body);
};

export const revertTransaction = (
  body: ICashoutRequest
): Promise<ICashoutResponse> => {
  const url = `${PAYMENT_BASE_URL_V2}${body.referenceTransactionId}/revert`;
  const descriptor = new ApiServiceManager(
    url,
    EHttpMethods.POST,
    defaultProvide
  );
  return fetchRequest(descriptor, body);
};

export const refundTransaction = (
  body: ICashoutRequest
): Promise<ICashoutResponse> => {
  const url = `${PAYMENT_BASE_URL_V2}${body.referenceTransactionId}/refund`;
  const descriptor = new ApiServiceManager(
    url,
    EHttpMethods.POST,
    defaultProvide
  );
  return fetchRequest(descriptor, body);
};
export const manualRefundTransaction = (
  body: ICashoutRequest
): Promise<ICashoutResponse> => {
  const url = `${PAYMENT_BASE_URL_V2}${body.referenceTransactionId}/manual-refund`;
  const descriptor = new ApiServiceManager(
    url,
    EHttpMethods.POST,
    defaultProvide
  );
  return fetchRequest(descriptor, body);
};

export const checkCashoutPayment = (
  referenceTransactionId: string,
  beneficiaryId: string | number
): Promise<ICashoutResponse> => {
  const url = `${PAYMENT_BASE_URL_V2}cashout/${referenceTransactionId}/status?beneficiaryId=${beneficiaryId}`;
  const descriptor = new ApiServiceManager(
    url,
    EHttpMethods.GET,
    defaultProvide
  );
  return fetchRequest(descriptor);
};

export const checkUserBank = (userId): Promise<IBankResponse> => {
  const url = `${AUTH_BASE_URL}${GET_BANKS_INFO(userId)}`;
  const descriptor = new ApiServiceManager(
    url,
    EHttpMethods.GET,
    defaultProvide
  );
  return fetchRequest(descriptor);
};

export const getOrgOwnerBanks = (
  userId
): Promise<IOrganizationBankInfoResponse> => {
  const url = `${AUTH_BASE_URL}/v2${GET_BANKS_INFO(userId)}`;
  const descriptor = new ApiServiceManager(
    url,
    EHttpMethods.GET,
    defaultProvide
  );
  return fetchRequest(descriptor);
};

export const getTransaction = (page = 0, size = 10): Promise<any> => {
  const url = `${PAYMENT_BASE_URL}${GET_TRANSACTION}?page=${page}&size=${size}`;
  const descriptor = new ApiServiceManager(
    url,
    EHttpMethods.GET,
    defaultProvide
  );
  return fetchRequest(descriptor);
};

export const getBalance = (id): Promise<any> => {
  const url = `${PAYMENT_BASE_URL}${GET_BALANCE(id)}`;
  const descriptor = new ApiServiceManager(
    url,
    EHttpMethods.GET,
    defaultProvide
  );
  return fetchRequest(descriptor);
};

export const makeOtherContractCashOutPayment = (
  body: ICashoutRequest
): Promise<ICashoutResponse> => {
  const url = `${PAYMENT_BASE_URL_V2}cashout`;
  const descriptor = new ApiServiceManager(
    url,
    EHttpMethods.POST,
    defaultProvide
  );
  return fetchRequest(descriptor, body);
};

export const makePaymentLinkCashout = (
  body: IPaymentLinkCashoutRequest
): Promise<ICashoutResponse> => {
  const url = `${PAYMENT_BASE_URL_V2}payment-link-cashout`;
  const descriptor = new ApiServiceManager(
    url,
    EHttpMethods.POST,
    defaultProvide
  );
  return fetchRequest(descriptor, body);
};

export const settleTabbyPayment = (
  orderNumber: string
): Promise<IApiResponse> => {
  const url = `${PAYMENT_BASE_URL_V2}${orderNumber}/settle`;
  const descriptor = new ApiServiceManager(
    url,
    EHttpMethods.POST,
    defaultProvide
  );
  return fetchRequest(descriptor);
};
